import { useTranslation } from "react-i18next";
import { colors } from "../../../data/colors";
import { numbersInclude } from "../../../data/stationery";
import { stdObject } from "../../../data/types/stdObject";
import { getAlignText } from "../../../utils/getAlignText";
import { toPrice } from "../../../utils/toPrice";
import writeBatchInfo from "../../DocumentModal/components/writeBatchInfo";
import { useStationeryContext } from "../../../context/MainContext";

export default function InnerTable({ lines }: stdObject) {
  const { t } = useTranslation();
  const { isPrint, paperData, actives, processTxt } = useStationeryContext();
  const { data, parts } = paperData;
  const tableRows = isPrint ? [0, ...lines] : [0, 1];

  const writeObservations = (v: stdObject | number, suf: string) => {
    const text = isPrint
      ? typeof v === "object"
        ? v[`OBS${suf}`]
        : false
      : t("c.OBS");
    return text ? <div>{text}</div> : false;
  };

  return (
    <div
      className="pageTableDiv"
      style={{
        backgroundColor: isPrint ? colors.white : "rgb(200 200 200 / 35%)",
        top: data.CABDOC,
        height: data.TALDOC,
      }}
    >
      <table
        align={getAlignText(Number(data.ALIDOC))}
        cellSpacing={0}
        cellPadding={data.PADDOC}
        style={{ width: data.TANDOC, fontSize: data.SIZDOC }}
      >
        <tbody>
          {tableRows.map((v: number | stdObject, index: number) => (
            <tr
              key={index}
              style={{
                backgroundColor: v === 0 ? data.CFODOC : colors.white,
                fontWeight: v === 0 && data.BOLDOC ? "bolder" : "",
              }}
            >
              {parts
                .filter((e: stdObject) => e.TIPPAR === 4 && actives[e.NUMPAR])
                .sort((a: stdObject, b: stdObject) => a.NIVPAR - b.NIVPAR)
                .map((e: stdObject, idx: number) => {
                  let style: stdObject = {};
                  if (e.ANCPAR > 0) {
                    style.width = e.ANCPAR;
                  }
                  return (
                    <td
                      key={idx}
                      valign="top"
                      style={{
                        textAlign: getAlignText(
                          Number(v === 0 ? data.ATADOC : e.ALIPAR),
                        ),
                        ...style,
                      }}
                    >
                      {isPrint && typeof v === "object"
                        ? numbersInclude.some((prefix) =>
                            e.PARPAR.startsWith(prefix),
                          )
                          ? toPrice(v[e.PARPAR])
                          : v[e.PARPAR]
                        : processTxt(e)}
                      {!data.HOBDOC &&
                        index > 0 &&
                        e.PARPAR.startsWith("NOM") &&
                        writeObservations(v, e.PARPAR.slice(-3))}
                      {!data.HSNDOC &&
                        index > 0 &&
                        e.PARPAR.startsWith("NOM") &&
                        (isPrint ? (
                          typeof v === "object" &&
                          !!v.BATCHES?.length &&
                          writeBatchInfo(v.BATCHES)
                        ) : (
                          <div>
                            <b>S/N: </b>
                            {t("p.batches")}
                          </div>
                        ))}
                    </td>
                  );
                })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
